import React from 'react';
import './FactionBeastmenDescription.css';
import DescriptionValueWithIcon from "../../../PolicyCardOverlay/DescriptionValueWithIcon/DescriptionValueWithIcon";
import {
  BEASTMEN_SIZE_FOR_SUPPLY_ON_BARRACKS,
  BEASTMEN_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP,
  BEASTMEN_WIN_POINTS_BONUS_ON_KILL
} from "../../../../configs/factions/beastmen";
import {WinPointsStat} from "../../../PlayerStat/stats/WinPointsStat";

const FactionBeastmenDescription = () => {
  const supply = <img
    className="faction-description-icon faction-description-icon-margin-right-left"
    src="/img/icons/supply.png"
    alt="Cнабжение"
    title={'Снабжение'}
  />;

  const size = <img
    className="faction-description-icon"
    src="/img/icons/unit size.png"
    alt="размер"
    title={'Размер отряда'}
  />;

  const barracks = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-right-left'}
    src={'/img/hexes/barracks.efab12f7.png'}
    alt={'Казарма'}
    title={'Казарма'}
  />;

  const militaryCamp = <img
    className={'policy-description-icon-building policy-description-icon-building-margin-left'}
    src={'/img/hexes/special buildings/military camp.1216e2cd.png'}
    alt={'Лагерь'}
    title={'Лагерь'}
  />;

  const unit = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right'}
    src={'/img/icons/unit d6 friend.png'}
    alt={'Отряд'}
    title={'Отряд'}
  />;
  const unitEnemy = <img
    className={'policy-description-icon-unit policy-description-icon-unit-margin-right-left'}
    src={'/img/icons/unit d6 enemy.png'}
    alt={'Отряд противника'}
    title={'Отряд противника'}
  />;

  const sizeBarracksValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right-left'}
    value={BEASTMEN_SIZE_FOR_SUPPLY_ON_BARRACKS}
    icon={size}
  />
  const sizeMilitaryCampValueAndIcon = <DescriptionValueWithIcon
    className={'policy-description-icon-margin-right'}
    value={BEASTMEN_SIZE_FOR_SUPPLY_WITH_MILITARY_CAMP}
    icon={size}
  />

  const winPoints = <WinPointsStat
    text={`+${BEASTMEN_WIN_POINTS_BONUS_ON_KILL}`}
    noShrinkOnMobile={true}
    isDarkColor={true}
    className={'policy-description-icon-margin-right-left'}
  />;

  return (
    <>
      <div className="policy-description_line">
        В
        <span className={'text-supply policy-description-icon-margin-left-end'}>
          фазе Снабжения
        </span>
        {unit} со {supply}
      </div>
      <div className="policy-description_line">
        получает {sizeBarracksValueAndIcon} на {barracks} ({sizeMilitaryCampValueAndIcon} смежно {militaryCamp}).
      </div>
      <div className="policy-description_line policy-description_line-margin-top-paragraph">
        Уничтожение {unitEnemy} дает {winPoints}.
      </div>
    </>
  );
};

export default FactionBeastmenDescription;
